// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3VOis","delete":"styles_delete__AT7Fv","update":"styles_update__1cix4","add":"styles_add__2NoM7"};